import { initOAuth2Flow } from 'app-redux/actions/login.actions';
import { AppState } from 'app-redux/reducers';
import { getCurrentUser } from 'app-redux/selectors/accounts.selector';
import { IUserAccount } from 'core/accounts/models';
import { INavigationRouteProps } from 'core/navigation/models';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';
import { isUK, translationWrapper } from 'utils/common-methods';
import protectorIcon from '../../assets/images/protector-icon.svg';
import protectorLaptop from '../../assets/images/protector_laptop.png';
import { history, RoutePaths } from '../../core/history';
import './styles.less';

interface IProtectorChoosePlan extends INavigationRouteProps<{}> {
  currentUser?: IUserAccount;
}

const ProtectorChoosePlanComponent: React.FC<IProtectorChoosePlan> = (props) => {
  const currentWorkspaceId = props.currentUser?.default_workspace_id || props.currentUser?.workspaces[0].workspace_id;

  const onTermsOfUseClick = async () => {
    history.push({
      pathname: RoutePaths.LEGAL('US'),
      search: location.search
    });
  };

  const redirectToAvailableProductsDeepAction = () => {
    const currentUrl = Buffer.from(window.location.href).toString('base64');
    const deepActionBaseURL = isUK() ? process.env.FARM_SETTINGS_UK_URL : process.env.FARM_SETTINGS_CW_URL;
    if (currentWorkspaceId) {
      window.location.href = `${deepActionBaseURL}/app/deep-actions/available-products?workspace=${currentWorkspaceId}&confirmation_method=stripe&callback_uri=${currentUrl}`;
    } else {
      initOAuth2Flow(history.location.pathname);
    }
  };

  const { t } = translationWrapper(useTranslation(), false);

  return (
    <div className="protector-plan-container">
      <div className="protector-plan-container__right">
        <div className="protector-plan-text-container">
          <div className="protector-plan-text-container__upper">
            <span style={{ color: '#F1F1F1' }}>{t('Choose your')}</span>
            <span style={{ color: '#00004B', position: 'absolute', top: '38px' }}>{t('Protector plan')}</span>
          </div>
          <div className="protector-plan-text-container__lower">
            <span>
              {t('Check out the Protector Plans to explore advanced features and functionality.')}
            </span>
          </div>
        </div>
          <div className="protector-buy-container">
            <div className="protector-buy-container__box">
              <img alt="" src={protectorIcon} />
              <span>{t('Protector AICC')}</span>
              <div className="protector-buy-container__box__list">
                <span style={{ fontSize: '15.02px' }}>
                  {t('With the offer you’ll have access to:')}
                  <ul>
                    <li>{t('Cereal Disease Risk Forecasting')}</li>
                    <li>{t('High resolution Satellite Imagery')}</li>
                    <li>{t('Customisable Crop Monitoring Plans')}</li>
                  </ul>
                </span>
              </div>
            </div>
            <Button
              className="protector-buy-container__button"
              type={ButtonType.primary}
              size="middle"
              onClick={redirectToAvailableProductsDeepAction}
            >
              {t('Buy now')}
            </Button>
            <span
                className="protector-buy-container__span"
                onClick={onTermsOfUseClick}
            >
              {t('Terms of use')}
            </span>
          </div>
      </div>
      <div className="protector-plan-container__left">
        <img src={protectorLaptop} alt="" />
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  currentUser: getCurrentUser(state),
});

const mapDispatchToProps = (dispatch: any) => ({});

export const ProtectorChoosePlan = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProtectorChoosePlanComponent),
);
